<template>
      <b-row class="mt-3 justify-content-center">
        <b-col md="8">
          <div class="alert alert-warning" v-if="!family.fee_paid">Atenção! A sua Família tem a Quota por Pagar. Terá que regularizar a quota para poder inscrever os seus filhos nos campos. Se tiver alguma questão, contacte via secretaria@camtil.pt</div>
          <b-card title="Família" class="grey_card">
            <dl class="row">
                  <dt class="col-sm-3 text-md-right">Apelido</dt>
                  <dd class="col-sm-9">{{ family.surname }}</dd>
                  <dt class="col-sm-3 text-md-right">Email</dt>
                  <dd class="col-sm-9">{{ family.email }}</dd>
                  <dt class="col-sm-3 text-md-right">Telefone</dt>
                  <dd class="col-sm-9">{{ family.phone }}</dd>
                  <dt class="col-sm-3 text-md-right">Morada</dt>
                  <dd class="col-sm-9">{{ family.address }}</dd>
                  <dt class="col-sm-3 text-md-right">Código Postal</dt>
                  <dd class="col-sm-9">{{ family.zip_code }}</dd>
                  <dt class="col-sm-3 text-md-right">Localidade</dt>
                  <dd class="col-sm-9">{{ family.locality }}</dd>
            </dl>
            </b-card>
            <b-card title="Dados dos pais" class="grey_card">
                <dl class="row" v-for="(par, index) in family.parents.data" :key="index">
                  <dt class="col-sm-3 text-md-right">Nome</dt>
                  <dd class="col-sm-9">{{ par.name }}</dd>
                  <dt class="col-sm-3 text-md-right">Email</dt>
                  <dd class="col-sm-9">{{ par.email }}</dd>
                  <dt class="col-sm-3 text-md-right">Telefone</dt>
                  <dd class="col-sm-9">{{ par.phone }}</dd>
                  <dt class="col-sm-3 text-md-right">Data de nascimento</dt>
                  <dd class="col-sm-9">{{ par.birth_date }}</dd>
                </dl>
            </b-card>
            <b-card title="Dados dos filhos" class="grey_card">
                <dl class="row" v-for="(kid,index) in family.children.data" :key="index">
                  <dt class="col-sm-3 text-md-right">Nome</dt>
                  <dd class="col-sm-9">{{ kid.name }}</dd>
                  <dt class="col-sm-3 text-md-right">Data de nascimento</dt>
                  <dd class="col-sm-9">{{ kid.birth_date }}</dd>
                  <dt class="col-sm-3 text-md-right"></dt>
                  <dd class="col-sm-9"  v-if="family.fee_paid">
                    <span v-if="kid.has_registration == 0"><router-link v-for="activity in kid.activities" :key="activity.id" :to="{name:'registrations', params: { personId: kid.id, activityId: activity.id }}" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Inscrever em {{ activity.name }}</router-link></span>
                    <span v-else><router-link v-for="activity in kid.activities" :key="activity.id" :to="{name:'view_registration', params: { personId: kid.id, activityId: activity.id }}" class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Ver Inscriçao</router-link></span>
                  </dd>

                  
                </dl>
          </b-card>
        </b-col>
      </b-row>
</template>


<script>
export default {
  name: "LoginForm",
  data() {
    return {
      working: false,
      family: null
    };
  },
  methods: {
  },
  created() {
      
      this.axios.get('front/family').then(response => {
          this.family = response.data.data
      })
  }
};
</script>